"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var taskStatus = {
    CANCELLED: 'cancelled',
    FAIL: 'fail',
    INIT: 'initiated',
    SUCCESS: 'success'
};
exports.default = taskStatus;
